import {
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
  FormGroup,
} from '@angular/forms';

export class CustomValidator {
  noWhiteSpace(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (typeof control.value !== 'string' || control.value.length === 0) {
        return null; // Se il valore non è una stringa, non applicare il validatore
      }
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { whitespace: true };
    };
  }

  valoreMinoreUgualeValidator(group: FormGroup): ValidationErrors | null {
    const votazioneControl = group.get('votazione');
    const votazione = votazioneControl?.value?.split('/')[0]?.trim();
    const massimoVotazione = votazioneControl?.value?.split('/')[1]?.trim();

    if (votazione && massimoVotazione) {
      if (!isNaN(votazione) && !isNaN(massimoVotazione)) {
        const valoreControl1 = +votazione; // Converti il valore in un numero
        const valoreControl2 = +massimoVotazione;

        // Verifica se il valore del primo controllo è maggiore del secondo
        if (valoreControl1 == 0 || valoreControl1 > valoreControl2) {
          // Restituisci un errore se la condizione non è soddisfatta
          return { valoreMinoreUguale: true };
        }
      }
    }
    return null;
  }

  atLeastOneCheckboxCheckedValidator(group: FormGroup): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const controls = group.controls;
      const checked = Object.keys(controls).some((key) => controls[key].value);
      return checked ? null : { atLeastOneCheckboxChecked: true };
    };
  }

  dateValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      let invalid = false;
      const value = control.value;
      if (value) {
        const year = value?.year();
        if (year < 1900 || year > new Date().getFullYear()) {
          invalid = true;
        }
      }
      return invalid ? { dateInvalid: true } : null;
    };
  }

  dateGraterOrTodayValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const now = new Date();
      now.setHours(0, 0, 0, 0);

      if (!control?.value) {
        return { invalidDate: true };
      }

      const valueAsDate = new Date(control.value);
      valueAsDate.setHours(0, 0, 0, 0);

      return valueAsDate < now ? { dateSmallerThanToday: true } : null;
    };
  }

  timeGraterThanNowValidator(date?: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const now = new Date();

      const valueH = control?.value?.split(':')?.at(0) ?? null;
      const valueM = control?.value?.split(':')?.at(1) ?? null;

      if (!valueH || !valueM) {
        return { invalidTime: true };
      }

      if (!date) {
        return { invalidDate: true };
      }

      const valueAsDate = new Date(date);
      valueAsDate.setHours(valueH, valueM, 0, 0);

      return valueAsDate <= now ? { timeSmallerOrEqualNow: true } : null;
    };
  }
}
